var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { PacemEventTarget, Watch, PropertyConverters, Utils, CustomElement, Logging, P } from '@pacem/pacem-core';
const DEFAULT_CONFIG = {
    error: true, info: true, warn: true
};
let PacemConsoleElement = class PacemConsoleElement extends PacemEventTarget {
    constructor() {
        super(...arguments);
        this._config = DEFAULT_CONFIG;
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'configuration') {
            this._config = Utils.extend({}, DEFAULT_CONFIG, val ?? {});
        }
    }
    log(level, message, category) {
        try {
            /* console enabled? better check: you might find cumbersome behaviors on IE/Edge when F12 tools aren't available! */
            this._log(level, message, category);
        }
        catch (e) { }
    }
    _log(level, message, category) {
        // enabled?
        if (!this.disabled && this._config[level] === true) {
            if (category !== this._category) {
                if (!Utils.isNullOrEmpty(this._category))
                    console.groupEnd();
                if (!Utils.isNullOrEmpty(category)) {
                    console.group(category);
                }
                this._category = category;
            }
            var fn = (m) => { };
            switch (level) {
                case Logging.LogLevel.Debug:
                    fn = console.debug;
                    break;
                case Logging.LogLevel.Error:
                    fn = console.error;
                    break;
                case Logging.LogLevel.Info:
                    fn = console.info;
                    break;
                case Logging.LogLevel.Trace:
                    fn = console.trace;
                    break;
                case Logging.LogLevel.Warn:
                    fn = console.warn;
                    break;
                case Logging.LogLevel.Log:
                    fn = console.log;
                    break;
            }
            fn(new Date().toISOString() + ': ' + message);
        }
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Json })
], PacemConsoleElement.prototype, "configuration", void 0);
PacemConsoleElement = __decorate([
    CustomElement({ tagName: P + '-console' })
], PacemConsoleElement);
export { PacemConsoleElement };
